export default "__VITE_ASSET__454ec6ea__"